<div class="container">
    <div class="header">
      <h2>Edit Tag Description</h2>
      <button mat-icon-button class="close-button" (click)="closeDialog(false)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  
  
    <h3 class="name-container">Name: {{ name }}</h3>
    <mat-form-field class="input">
      <mat-label>Description:</mat-label>
      <input matInput type="text" [(ngModel)]="description" />
    </mat-form-field>
  
    <h2>Emails for Device Status Updates:</h2>
    @if(emailsFormControl.length === 0){
    <button mat-icon-button (click)="addNewEmail()" style="border: 0px"><mat-icon>add</mat-icon></button>
    }
    <div class="emails">
      @for(email of emailsFormControl.controls;track email; let last = $last; let i = $index){
      <div class="email-entry">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Email:</mat-label>
          <input matInput [formControl]="email" />
          <button matSuffix mat-icon-button aria-label="Remove" (click)="emailsFormControl.removeAt(i)">
            <mat-icon>remove</mat-icon>
          </button>
          @if (email.errors?.['required'] && email.touched) {
          <mat-error>This field is required</mat-error>
          }@else if(email.errors?.['email'] && email.touched){
          <mat-error>Invalid Email</mat-error>
          }
        </mat-form-field>
        <div class="button-container">
          @if(last){
          <button mat-icon-button (click)="addNewEmail()" style="border: 0px"><mat-icon>add</mat-icon></button>
          }
        </div>
      </div>
      }
    </div>
  
    <div class="buttons">
      <button mat-raised-button (click)="closeDialog(true)">Save</button>
      <button mat-raised-button (click)="closeDialog(false)">Cancel</button>
    </div>
  </div>
  